import { render, staticRenderFns } from "./QuickClientForm.vue?vue&type=template&id=793a39a7&"
import script from "./QuickClientForm.vue?vue&type=script&lang=js&"
export * from "./QuickClientForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports